import http from '@/utils/request'

// 文章列表
export const postPageList= (params) => http.post(`/cmsArticle/postPageList`, params)
export const getDetail= (params) => http.get(`/cmsArticle/getDetail`, params)
export const getHomeCategoryList= (params) => http.post(`/cmsArticle/getHomeList`, params)
